import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { ProjectCard } from './ProjectCard';
import { projects } from '../data/site';
export function Projects() {
  const [lead, ...rest] = projects;
  return <section id="projects" className="border-b border-hairline bg-white" data-id="element-75" data-mp="ukxby93458hp">
      <div className="mx-auto max-w-shell px-4 py-20 sm:px-8" data-id="element-76" data-mp="pu8fsgghnnc8">
        <div className="max-w-2xl" data-id="element-77" data-mp="prvq1h4ho8om">
          <p className="font-mono text-xs uppercase tracking-[0.14em] text-muted" data-id="element-78" data-mp="13l3l5irs3mb2">
            open source
          </p>
          <h2 className="mt-4 text-[clamp(1.9rem,3.6vw,3rem)] font-semibold leading-[1.02] tracking-tightest text-ink" data-id="element-79" data-mp="yl8r56cpigls">
            Four projects, one pipeline
          </h2>
          <p className="mt-4 text-base text-muted" data-id="element-80" data-mp="18kpxlpzs8yit">
            Each tool is useful on its own and better together. We maintain all of them in the
            open, under MIT, with the same team behind every release.
          </p>
        </div>

        <div className="mt-12 grid gap-4 lg:grid-cols-3" data-id="element-81" data-mp="3ade180gc9nz4">
          <a id={lead.href.slice(1)} href={lead.href} className="group flex flex-col justify-between rounded-2xl bg-ink p-8 text-white transition-colors duration-200 void-ease hover:bg-void-dark lg:row-span-2 lg:p-10" data-id="element-82" data-mp="1xckiv9m98ulw">
            <div style={{
            paddingTop: "16px",
            paddingBottom: "16px",
            paddingLeft: "23px",
            paddingRight: "16px",
            width: "328px",
            height: "256px"
          }} data-id="element-83" data-mp="26aw6r3vqlean">
              <div className="flex items-start justify-between gap-4" data-id="element-84" data-mp="2g1h28ig462pc">
                <span className="font-mono text-2xl lowercase text-white" data-id="element-85" data-mp="2l1d6misq3w5f">{lead.wordmark}</span>
                <ArrowUpRightIcon className="h-5 w-5 text-white/60 transition-transform duration-150 void-ease group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-86" data-mp="2p3gkfe2v7ctv" />
              </div>
              <h3 className="mt-8 max-w-sm text-3xl font-semibold leading-[1.06] tracking-tightest lg:text-4xl" data-id="element-87" data-mp="up79h3j0nojn">
                {lead.tagline}
              </h3>
              <p className="mt-5 max-w-md text-sm leading-relaxed text-white/70" data-id="element-88" data-mp="zosiy7vtbfam">
                {lead.description}
              </p>
            </div>
            <p className="mt-12 font-mono text-xs text-white/60" data-id="element-89" data-mp="1y0d2b7vwdjwx">
              <span className="text-base text-white" data-id="element-90" data-mp="1y26a4qi8ya6i">{lead.stat}</span> {lead.statLabel}
            </p>
          </a>

          {rest.map(p => <ProjectCard key={p.name} id={p.href.slice(1)} href={p.href} wordmark={p.wordmark} tagline={p.tagline} description={p.description} stat={p.stat} statLabel={p.statLabel} className="lg:col-span-2" data-id="element-91" data-mp="270i5f5u25w5a" />)}
        </div>
      </div>
    </section>;
}